import { Typography } from '@aloft/toolkit-sui';

import { usePropertyField } from './shared/usePropertyField.tsx';
import { readOnlyFieldProps } from './styles.ts';
import { PropertyGridFieldProps } from './types.ts';

export const ReadOnlyField = ({
  columnIndex,
  field,
  colSpan = 1,
  isArv = false,
  control,
  getValues,
  gridType,
}: PropertyGridFieldProps) => {
  const { displayValue } = usePropertyField({ columnIndex, field, isArv, control, getValues });
  const isSensitivityGrid = gridType === 'SensitivityGrid';

  const props = readOnlyFieldProps(colSpan);
  if (isSensitivityGrid) {
    props.__dangerDoNotUseSx = {
      ...props.__dangerDoNotUseSx,
      backgroundColor: 'white',
    };
  }

  return <Typography {...props}>{displayValue}</Typography>;
};
